export const getTrend = (
  data: [Date, number][]
): 'positive' | 'negative' | 'neutral' => {
  if (data.length === 0) return 'neutral';
  const [_, firstValue] = data[0];
  const [__, lastValue] = data[data.length - 1];
  if (firstValue < lastValue) return 'positive';
  if (firstValue > lastValue) return 'negative';
  return 'neutral';
};
